import React from 'react'
import { Link } from 'react-router-dom'

export default function FloatingCTA() {
  return (
    <aside
      aria-label="Hurtig kontakt og bestilling"
      className="fixed bottom-6 right-6 z-40 flex flex-col items-center gap-3 print:hidden"
    >
      {/* Bestillingsformular Floating CTA */}
      <Link
        to="/kontakt"
        aria-label="Gå til bestillingsformular"
        title="Bestil transport online"
        className="group relative flex items-center justify-center w-12 h-12 sm:w-13 sm:h-13 rounded-full bg-sky-600 text-white hover:bg-sky-500 shadow-lg shadow-sky-600/30 transition-all duration-300 ease-in-out hover:scale-110 hover:shadow-xl active:scale-95"
      >
        <i className="fa-solid fa-file-lines text-lg sm:text-xl transition-transform duration-300 group-hover:scale-110" aria-hidden="true" />
      </Link>

      {/* Email Floating CTA */}
      <a
        href="mailto:transport4u.dk@gmail.com"
        aria-label="Send en e-mail til transport4u.dk@gmail.com"
        title="Send en e-mail: transport4u.dk@gmail.com"
        className="group relative flex items-center justify-center w-12 h-12 sm:w-13 sm:h-13 rounded-full bg-slate-900 text-sky-400 hover:text-white hover:bg-slate-800 border border-slate-700/80 shadow-lg shadow-slate-950/20 transition-all duration-300 ease-in-out hover:scale-110 hover:shadow-xl active:scale-95"
      >
        <i className="fa-solid fa-envelope text-lg sm:text-xl transition-transform duration-300 group-hover:scale-110" aria-hidden="true" />
      </a>

      {/* Phone Floating CTA */}
      <a
        href="tel:+4550352035"
        aria-label="Ring til 50 35 20 35"
        title="Ring: 50 35 20 35"
        className="group relative flex items-center justify-center w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-slate-100 text-slate-700 hover:bg-slate-200 border border-slate-300 shadow-md transition-all duration-300 ease-in-out hover:scale-105 active:scale-95"
      >
        <i className="fa-solid fa-phone text-base sm:text-lg transition-transform duration-300 group-hover:scale-110" aria-hidden="true" />
      </a>
    </aside>
  )
}
